import { Components, Theme } from "@mui/material";

export const vrCardOverride: Components<Theme>["MuiCard"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: "100%",
      height: "100%",
      backdropFilter: `blur(${theme.spacing(2)})`,
      backgroundColor: `${theme.palette.dsSurface.v200}50`,
      backgroundImage: "none",
      border: `1px solid ${theme.palette.dsBase.v200}10`,
      borderRadius: theme.spacing(4),
      boxShadow: "none",
      boxSizing: "border-box",
      cornerShape: "squircle",
    }),
  },
};
